import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZoomOut = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 27,
	viewBox: "0 0 24 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.03418 13.0355C6.03418 12.6282 6.20835 12.2981 6.4232 12.2981H13.4256C13.6405 12.2981 13.8146 12.6282 13.8146 13.0355C13.8146 13.4427 13.6405 13.7729 13.4256 13.7729H6.4232C6.20835 13.7729 6.03418 13.4427 6.03418 13.0355Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.80461 4.0376C4.96259 4.0376 1.03735 7.96402 1.03735 12.8075C1.03735 17.651 4.96259 21.5774 9.80461 21.5774C11.9386 21.5774 13.8946 20.8147 15.4149 19.547L21.4621 25.596C21.7733 25.9073 22.278 25.9073 22.5892 25.596C22.9005 25.2846 22.9005 24.7798 22.5892 24.4685L16.5421 18.4195C17.8094 16.8987 18.5719 14.9422 18.5719 12.8075C18.5719 7.96402 14.6466 4.0376 9.80461 4.0376ZM2.6314 12.8075C2.6314 8.84466 5.84296 5.63213 9.80461 5.63213C13.7663 5.63213 16.9778 8.84466 16.9778 12.8075C16.9778 16.7704 13.7663 19.9829 9.80461 19.9829C5.84296 19.9829 2.6314 16.7704 2.6314 12.8075Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgZoomOut;
